import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Subscription, debounceTime, distinctUntilChanged } from 'rxjs';
import { SharedModule } from '../../shared.module';
import { SkeletonLoaderComponent } from '../skeleton/skeleton.component';

@Component({
  selector: 'app-page-header',
  standalone: true,
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.scss',
  imports: [SharedModule, SkeletonLoaderComponent],
})
export class PageHeaderComponent implements OnInit, OnDestroy {
  @Input() searchPlaceholder: string = 'Search...';
  @Input() pageTitle: string = '';
  @Input() numberOfItem: number = 0;
  @Input() loading: boolean = false;
  @Output() searchEvent: EventEmitter<string> = new EventEmitter();
  @Input() showSearch = true;
  searchForm = this.fb.group({ searchText: [''] });
  subscription: Subscription = new Subscription();
  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.subscribeToSearchValueChanges();
  }

  subscribeToSearchValueChanges() {
    const valueChangeSub = this.searchForm
      .get('searchText')
      ?.valueChanges.pipe(distinctUntilChanged(), debounceTime(300))
      .subscribe((value: any) => {
        if (value.length === 0 || value?.trim()) {
          this.searchEvent.emit(value);
        }
      });
    this.subscription.add(valueChangeSub);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
